import React from "react";

const DiscountPopup = ({ onClose }) => {
  const handleOverlayClick = (e) => {
    // Close only when the actual overlay/background is clicked
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleOverlayClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(30, 40, 50, 0.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "20px",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "450px",
          backgroundColor: "#f9f9f9",
          border: "1px solid #d9d9d9",
          boxShadow: "0 15px 45px rgba(0, 0, 0, 0.15)",
          padding: "55px 40px",
          textAlign: "center",
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "12px",
            right: "15px",
            border: "none",
            background: "transparent",
            fontSize: "26px",
            fontWeight: "300",
            color: "#26384a",
            cursor: "pointer",
            lineHeight: 1,
          }}
          aria-label="Close"
        >
          &times;
        </button>

        <h2
          style={{
            margin: 0,
            fontSize: "32px",
            fontWeight: 500,
            letterSpacing: "1.5px",
            color: "#26384a",
          }}
        >
          FLAT 15% OFF
        </h2>

        <div
          style={{
            width: "45px",
            height: "1px",
            backgroundColor: "#26384a",
            margin: "22px auto",
          }}
        />

        <p
          style={{
            margin: 0,
            fontSize: "16px",
            lineHeight: 1.7,
            color: "#4d5965",
            fontWeight: 400,
          }}
        >
          Enjoy a flat{" "}
          <strong
            style={{
              color: "#26384a",
              fontWeight: 600,
            }}
          >
            15% off on everything
          </strong>
          ,
          <br />
          across the SYUKRA collection.
        </p>
      </div>
    </div>
  );
};

export default DiscountPopup;
